import React, { useEffect } from 'react';
import { withLoading } from '@adjust/dashboard-components';
import { AppIcon } from '@react/Common/AppIcon/AppIcon';
import { connectWithStore } from '@react/Common/connectWithStore';
import { getUserPermissionsState, selectCurrentApp } from '@redux/ducks/userPermissions/userPermissions';
import { fetchAppList, getAppState } from '@redux/ducks/app/app';

const AppListComponent = ({ searchTerm: search, appList, navigateToAppAccess, fetchAppList, access }) => {
  useEffect(() => {
    fetchAppList({ search, access });
  }, [fetchAppList, search, access]);

  return (
    <ul className="app-access-list ul-list-with-arrow">
      {appList.map(app => (
        <li key={app.token}>
          <a data-testid={`app-list-item-${app.token}`} onClick={() => navigateToAppAccess(app)}>
            {app.access ? <span className={`role-tag role-${app.access.role}`}>{t(app.access.role)}</span> : null}
            <AppIcon size="small" skeletonStyle="list" appId={app.default_store_app_id} />
            <span>{app.name}</span>
          </a>
        </li>
      ))}
    </ul>
  );
};

const mapStateToProps = state => {
  const { appList, isLoading, searchTerm } = getAppState(state);
  const { user } = getUserPermissionsState(state);

  return {
    access: user.local_roles.mobile_apps,
    appList,
    isLoading,
    searchTerm,
  };
};

const mapStateToDispatch = {
  navigateToAppAccess: selectCurrentApp,
  fetchAppList,
};

const AppListWithLoading = withLoading(AppListComponent, true);

export const AppList = connectWithStore(mapStateToProps, mapStateToDispatch)(AppListWithLoading);
